module.exports = __webpack_public_path__ + "static/media/International Hackers Meet-Up.33839c50.png";